import React, { useState, useEffect } from 'react';
import { ref, push, set, onValue } from 'firebase/database';
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../../firebase/config';
import { FaCloudUploadAlt, FaTrash, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import imageCompression from 'browser-image-compression';

const OrderNotPlaced = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [notification, setNotification] = useState({ show: false, message: '', type: '' });
    const [imagePreview, setImagePreview] = useState(null);
    const [compressedImage, setCompressedImage] = useState(null);
    const [imageSize, setImageSize] = useState(null);
    const [productQuantities, setProductQuantities] = useState({}); // { productId: quantity }
    const [districts, setDistricts] = useState([]);

    // Complete State and District data for all Indian States and UTs
    const stateDistrictData = {
        'Andhra Pradesh': ['Visakhapatnam', 'Vijayawada', 'Guntur', 'Nellore', 'Kurnool', 'Tirupati', 'Kakinada', 'Rajahmundry', 'Kadapa', 'Anantapur', 'Vizianagaram', 'Eluru', 'Ongole', 'Nandyal', 'Machilipatnam', 'Adoni', 'Tenali', 'Chittoor', 'Hindupur', 'Proddatur', 'Bhimavaram', 'Madanapalle', 'Guntakal', 'Dharmavaram', 'Gudivada', 'Srikakulam', 'Narasaraopet', 'Rajampet', 'Tadpatri', 'Tadepalligudem', 'Chilakaluripet', 'Yemmiganur', 'Kadiri', 'Chirala', 'Anakapalle', 'Kavali', 'Palacole', 'Sullurpeta', 'Tanuku', 'Rayachoti', 'Srikalahasti', 'Bapatla', 'Naidupet', 'Nagari', 'Gudur', 'Vinukonda', 'Narasapuram', 'Nuzvid', 'Markapur', 'Ponnur'],
        'Arunachal Pradesh': ['Itanagar', 'Naharlagun', 'Pasighat', 'Tawang', 'Ziro', 'Bomdila', 'Tezu', 'Seppa', 'Changlang', 'Along', 'Roing', 'Namsai', 'Khonsa', 'Daporijo', 'Anini', 'Yingkiong', 'Aalo', 'Hawai', 'Mechuka', 'Taliha', 'Jairampur', 'Longding'],
        'Assam': ['Guwahati', 'Silchar', 'Dibrugarh', 'Jorhat', 'Nagaon', 'Tinsukia', 'Tezpur', 'Bongaigaon', 'Dhubri', 'Diphu', 'North Lakhimpur', 'Karimganj', 'Sivasagar', 'Goalpara', 'Barpeta', 'Haflong', 'Nalbari', 'Rangia', 'Hojai', 'Lanka', 'Lumding', 'Mangaldoi', 'Sibsagar', 'Golaghat', 'Dhekiajuli', 'Dergaon', 'Duliajan', 'Gauripur', 'Hailakandi', 'Morigaon', 'Naharkatiya', 'Mariani', 'Nazira', 'Raha', 'Titabar', 'Kokrajhar', 'Abhayapuri', 'Dispur'],
        'Bihar': ['Patna', 'Gaya', 'Bhagalpur', 'Muzaffarpur', 'Purnia', 'Darbhanga', 'Bihar Sharif', 'Arrah', 'Begusarai', 'Katihar', 'Munger', 'Chhapra', 'Danapur', 'Bettiah', 'Saharsa', 'Hajipur', 'Sasaram', 'Dehri', 'Siwan', 'Motihari', 'Nawada', 'Bagaha', 'Buxar', 'Kishanganj', 'Sitamarhi', 'Jamalpur', 'Jehanabad', 'Aurangabad', 'Lakhisarai', 'Araria', 'Madhubani', 'Supaul', 'Samastipur', 'Raxaul', 'Forbesganj', 'Madhepura', 'Gopalganj', 'Vaishali', 'Sheohar', 'Sheikhpura', 'Jamui', 'Khagaria', 'Banka'],
        'Chhattisgarh': ['Raipur', 'Bhilai', 'Bilaspur', 'Korba', 'Durg', 'Rajnandgaon', 'Jagdalpur', 'Raigarh', 'Ambikapur', 'Mahasamund', 'Dhamtari', 'Chirmiri', 'Bhatapara', 'Dalli-Rajhara', 'Naila Janjgir', 'Tilda Newra', 'Mungeli', 'Manendragarh', 'Sakti', 'Dongargaon', 'Baloda', 'Bemetara', 'Balod', 'Kawardha', 'Kondagaon', 'Kanker', 'Bastar', 'Narayanpur', 'Bijapur', 'Dantewada', 'Sukma', 'Gariaband', 'Jashpur', 'Balrampur', 'Surajpur', 'Surguja', 'Korea'],
        'Goa': ['Panaji', 'Margao', 'Vasco da Gama', 'Mapusa', 'Ponda', 'Bicholim', 'Curchorem', 'Sanquelim', 'Cuncolim', 'Quepem', 'Canacona', 'Pernem'],
        'Gujarat': ['Ahmedabad', 'Surat', 'Vadodara', 'Rajkot', 'Bhavnagar', 'Jamnagar', 'Junagadh', 'Gandhinagar', 'Anand', 'Navsari', 'Morbi', 'Nadiad', 'Surendranagar', 'Bharuch', 'Mehsana', 'Bhuj', 'Porbandar', 'Palanpur', 'Valsad', 'Vapi', 'Gondal', 'Veraval', 'Godhra', 'Patan', 'Kalol', 'Dahod', 'Botad', 'Amreli', 'Deesa', 'Jetpur', 'Mahemdabad', 'Modasa', 'Keshod', 'Wadhwan', 'Ankleshwar', 'Savarkundla', 'Kadi', 'Visnagar', 'Upleta', 'Una', 'Sidhpur', 'Vyara', 'Mandvi', 'Thangadh', 'Viramgam', 'Radhanpur', 'Mahuva', 'Dholka', 'Ranavav', 'Thasra'],
        'Haryana': ['Faridabad', 'Gurgaon', 'Hisar', 'Rohtak', 'Panipat', 'Karnal', 'Sonipat', 'Yamunanagar', 'Panchkula', 'Bhiwani', 'Bahadurgarh', 'Jind', 'Sirsa', 'Thanesar', 'Kaithal', 'Palwal', 'Rewari', 'Hansi', 'Narnaul', 'Fatehabad', 'Gohana', 'Tohana', 'Narwana', 'Mandi Dabwali', 'Charkhi Dadri', 'Shahbad', 'Pehowa', 'Samalkha', 'Pinjore', 'Ladwa', 'Sohna', 'Safidon', 'Taraori', 'Mahendragarh', 'Ratia', 'Rania', 'Sarsod'],
        'Himachal Pradesh': ['Shimla', 'Mandi', 'Solan', 'Nahan', 'Sundarnagar', 'Palampur', 'Kullu', 'Hamirpur', 'Una', 'Bilaspur', 'Chamba', 'Kangra', 'Dharamshala', 'Baddi', 'Nalagarh', 'Paonta Sahib', 'Parwanoo', 'Nurpur', 'Jawalamukhi', 'Jogindernagar', 'Dalhousie', 'Manali', 'Rampur', 'Amb', 'Arki', 'Kinnaur', 'Lahaul', 'Spiti', 'Kasauli', 'Narkanda'],
        'Jharkhand': ['Ranchi', 'Jamshedpur', 'Dhanbad', 'Bokaro', 'Deoghar', 'Phusro', 'Hazaribagh', 'Giridih', 'Ramgarh', 'Medininagar', 'Chirkunda', 'Gumla', 'Dumka', 'Godda', 'Chaibasa', 'Chatra', 'Lohardaga', 'Sahibganj', 'Pakur', 'Jhumri Telaiya', 'Koderma', 'Mihijam', 'Saunda', 'Simdega', 'Jamtara', 'Bundu', 'Chas', 'Khunti', 'Latehar', 'Garhwa', 'Hussainabad', 'Chandil', 'Tenu dam-cum-Kathhara'],
        'Karnataka': ['Bangalore', 'Mysore', 'Hubli', 'Mangalore', 'Belgaum', 'Gulbarga', 'Davanagere', 'Bellary', 'Bijapur', 'Shimoga', 'Tumkur', 'Raichur', 'Bidar', 'Hospet', 'Hassan', 'Gadag-Betigeri', 'Udupi', 'Robertson Pet', 'Bhadravati', 'Chitradurga', 'Kolar', 'Mandya', 'Chikmagalur', 'Gangavati', 'Bagalkot', 'Ranebennuru', 'Karwar', 'Madhugiri', 'Sirsi', 'Adyar', 'Haveri', 'Ramanagaram', 'Tiptur', 'Bhalki', 'Bagepalli', 'Arsikere', 'Koppal', 'Channapatna', 'Athni', 'Yadgir'],
        'Kerala': ['Thiruvananthapuram', 'Kochi', 'Kozhikode', 'Kollam', 'Thrissur', 'Palakkad', 'Alappuzha', 'Malappuram', 'Kannur', 'Kottayam', 'Kasaragod', 'Pathanamthitta', 'Idukki', 'Wayanad', 'Thalassery', 'Kanhangad', 'Payyanur', 'Koyilandy', 'Perinthalmanna', 'Cherthala', 'Adoor', 'Nedumangad', 'Kattappana', 'Nilambur', 'Changanassery', 'Punalur', 'Tirur', 'Kayamkulam', 'Vaikom', 'Manjeri', 'Paravur', 'Neyyattinkara', 'Haripad', 'Ponnani', 'Muvattupuzha', 'Chengannur'],
        'Madhya Pradesh': ['Indore', 'Bhopal', 'Jabalpur', 'Gwalior', 'Ujjain', 'Sagar', 'Dewas', 'Satna', 'Ratlam', 'Rewa', 'Katni', 'Singrauli', 'Burhanpur', 'Khandwa', 'Bhind', 'Chhindwara', 'Guna', 'Shivpuri', 'Vidisha', 'Damoh', 'Mandsaur', 'Khargone', 'Neemuch', 'Pithampur', 'Hoshangabad', 'Itarsi', 'Sehore', 'Betul', 'Seoni', 'Datia', 'Nagda', 'Dhar', 'Morena', 'Balaghat', 'Tikamgarh', 'Shahdol', 'Chhatarpur', 'Harda', 'Shajapur', 'Mandla', 'Sidhi', 'Sendhwa', 'Ashok Nagar', 'Raghogarh-Vijaypur'],
        'Maharashtra': ['Mumbai', 'Pune', 'Nagpur', 'Thane', 'Nashik', 'Kalyan-Dombivali', 'Vasai-Virar', 'Solapur', 'Mira-Bhayandar', 'Bhiwandi', 'Amravati', 'Navi Mumbai', 'Aurangabad', 'Kolhapur', 'Ulhasnagar', 'Sangli', 'Malegaon', 'Jalgaon', 'Akola', 'Latur', 'Dhule', 'Ahmednagar', 'Ichalkaranji', 'Parbhani', 'Panvel', 'Yavatmal', 'Achalpur', 'Osmanabad', 'Nanded', 'Satara', 'Wardha', 'Udgir', 'Bid', 'Jalna', 'Gondia', 'Barshi', 'Ratnagiri', 'Chandrapur', 'Palghar', 'Sindhudurg', 'Bhandara', 'Gadchiroli', 'Hingoli', 'Washim'],
        'Manipur': ['Imphal', 'Thoubal', 'Bishnupur', 'Churachandpur', 'Ukhrul', 'Senapati', 'Tamenglong', 'Chandel', 'Kakching', 'Jiribam', 'Moirang', 'Mayang Imphal', 'Yairipok', 'Moreh', 'Kangpokpi', 'Noney', 'Tengnoupal', 'Kamjong', 'Pherzawl'],
        'Meghalaya': ['Shillong', 'Tura', 'Nongstoin', 'Jowai', 'Baghmara', 'Williamnagar', 'Nongpoh', 'Mairang', 'Resubelpara', 'Cherrapunji', 'Mawlai', 'Nongmynsong', 'Nongthymmai', 'Mawkyrwat', 'Khliehriat', 'Ampati', 'Sohra'],
        'Mizoram': ['Aizawl', 'Lunglei', 'Saiha', 'Champhai', 'Kolasib', 'Serchhip', 'Lawngtlai', 'Mamit', 'Hnahthial', 'Saitual', 'Khawzawl', 'North Vanlaiphai'],
        'Nagaland': ['Kohima', 'Dimapur', 'Mokokchung', 'Tuensang', 'Wokha', 'Zunheboto', 'Phek', 'Mon', 'Kiphire', 'Longleng', 'Peren', 'Noklak', 'Chumukedima', 'Tseminyu'],
        'Odisha': ['Bhubaneswar', 'Cuttack', 'Rourkela', 'Brahmapur', 'Sambalpur', 'Puri', 'Balasore', 'Bhadrak', 'Baripada', 'Jharsuguda', 'Jeypore', 'Bargarh', 'Balangir', 'Rayagada', 'Bhawanipatna', 'Dhenkanal', 'Barbil', 'Kendujhar', 'Sunabeda', 'Talcher', 'Titlagarh', 'Paradip', 'Angul', 'Phulabani', 'Koraput', 'Nabarangpur', 'Nayagarh', 'Kendrapara', 'Jajpur', 'Jagatsinghpur', 'Ganjam', 'Gajapati', 'Kandhamal', 'Kalahandi', 'Deogarh', 'Sonepur', 'Nuapada', 'Malkangiri'],
        'Punjab': ['Ludhiana', 'Amritsar', 'Jalandhar', 'Patiala', 'Bathinda', 'Mohali', 'Pathankot', 'Hoshiarpur', 'Batala', 'Moga', 'Malerkotla', 'Khanna', 'Muktsar', 'Barnala', 'Rajpura', 'Firozpur', 'Kapurthala', 'Faridkot', 'Sunam', 'Gurdaspur', 'Sangrur', 'Fazilka', 'Mansa', 'Nawanshahr', 'Tarn Taran', 'Rupnagar', 'Fatehgarh Sahib', 'Abohar', 'Malout', 'Samrala', 'Kharar', 'Zirakpur', 'Kot Kapura', 'Rampura Phul', 'Dhuri', 'Nabha', 'Morinda', 'Zira', 'Phillaur', 'Nangal'],
        'Rajasthan': ['Jaipur', 'Jodhpur', 'Kota', 'Bikaner', 'Ajmer', 'Udaipur', 'Bhilwara', 'Alwar', 'Bharatpur', 'Pali', 'Barmer', 'Sikar', 'Tonk', 'Sadulpur', 'Sawai Madhopur', 'Nagaur', 'Makrana', 'Sujangarh', 'Sardarshahar', 'Ladnu', 'Ratangarh', 'Hanumangarh', 'Rajsamand', 'Didwana', 'Kishanganj', 'Beawar', 'Jhunjhunu', 'Gangapur City', 'Churu', 'Jhalawar', 'Bundi', 'Baran', 'Chittorgarh', 'Dungarpur', 'Banswara', 'Pratapgarh', 'Sirohi', 'Jalore', 'Hanumangarh', 'Karauli', 'Dausa', 'Dholpur'],
        'Sikkim': ['Gangtok', 'Namchi', 'Gyalshing', 'Mangan', 'Pelling', 'Rangpo', 'Jorethang', 'Singtam', 'Ravangla', 'Pakyong'],
        'Tamil Nadu': ['Chennai', 'Coimbatore', 'Madurai', 'Tiruchirappalli', 'Salem', 'Tirunelveli', 'Tiruppur', 'Ranipet', 'Nagercoil', 'Thanjavur', 'Vellore', 'Kancheepuram', 'Erode', 'Tiruvannamalai', 'Pollachi', 'Rajapalayam', 'Sivakasi', 'Pudukkottai', 'Neyveli', 'Nagapattinam', 'Viluppuram', 'Tiruchengode', 'Vaniyambadi', 'Theni', 'Arakkonam', 'Kumarapalayam', 'Karaikkudi', 'Neyveli', 'Cuddalore', 'Kumbakonam', 'Tirupur', 'Avadi', 'Pallavaram', 'Ambattur', 'Tambaram', 'Dindigul', 'Karur', 'Namakkal', 'Krishnagiri', 'Dharmapuri', 'Ariyalur'],
        'Telangana': ['Hyderabad', 'Warangal', 'Nizamabad', 'Khammam', 'Karimnagar', 'Ramagundam', 'Mahbubnagar', 'Nalgonda', 'Adilabad', 'Suryapet', 'Siddipet', 'Miryalaguda', 'Jagtial', 'Mancherial', 'Nirmal', 'Kothagudem', 'Bodhan', 'Sangareddy', 'Metpally', 'Zahirabad', 'MeerpetJillelguda', 'Korutla', 'Tandur', 'Badepally', 'Kodad', 'Armoor', 'Gadwal', 'Wanaparthy', 'Kagaznagar', 'Bellampalle', 'Kamareddy', 'Palwancha', 'Kottagudem', 'Sircilla', 'Vikarabad', 'Jangaon', 'Medak', 'Bhongir'],
        'Tripura': ['Agartala', 'Udaipur', 'Dharmanagar', 'Ambassa', 'Belonia', 'Kailasahar', 'Khowai', 'Teliamura', 'Sabroom', 'Sonamura', 'Kamalpur', 'Amarpur', 'Kumarghat', 'Ranirbazar', 'Melaghar', 'Mohanpur'],
        'Uttar Pradesh': ['Lucknow', 'Kanpur', 'Ghaziabad', 'Agra', 'Varanasi', 'Meerut', 'Allahabad', 'Bareilly', 'Aligarh', 'Moradabad', 'Saharanpur', 'Gorakhpur', 'Noida', 'Firozabad', 'Jhansi', 'Muzaffarnagar', 'Mathura', 'Rampur', 'Shahjahanpur', 'Farrukhabad-cum-Fatehgarh', 'Maunath Bhanjan', 'Hapur', 'Ayodhya', 'Etawah', 'Mirzapur-Vindhyachal', 'Bulandshahr', 'Sambhal', 'Amroha', 'Hardoi', 'Fatehpur', 'Raebareli', 'Orai', 'Sitapur', 'Bahraich', 'Modinagar', 'Unnao', 'Jaunpur', 'Lakhimpur', 'Hathras', 'Banda', 'Pilibhit', 'Barabanki', 'Khurja', 'Gonda', 'Mainpuri', 'Lalitpur', 'Etah', 'Deoria', 'Ghazipur', 'Sultanpur'],
        'Uttarakhand': ['Dehradun', 'Haridwar', 'Roorkee', 'Haldwani', 'Rudrapur', 'Kashipur', 'Rishikesh', 'Pithoragarh', 'Jaspur', 'Ramnagar', 'Kotdwara', 'Manglaur', 'Nainital', 'Mussoorie', 'Tehri', 'Pauri', 'Nagla', 'Sitarganj', 'Bageshwar', 'Almora', 'Chamoli', 'Champawat', 'Rudraprayag', 'Uttarkashi', 'Tanakpur', 'Kichha', 'Doiwala', 'Vikasnagar', 'Laksar'],
        'West Bengal': ['Kolkata', 'Howrah', 'Durgapur', 'Asansol', 'Siliguri', 'Bardhaman', 'Malda', 'Baharampur', 'Habra', 'Kharagpur', 'Shantipur', 'Dankuni', 'Dhulian', 'Raiganj', 'Ranaghat', 'Haldia', 'Krishnanagar', 'Nabadwip', 'Medinipur', 'Jalpaiguri', 'Balurghat', 'Basirhat', 'Bankura', 'Chakdaha', 'Darjeeling', 'Alipurduar', 'Purulia', 'Jangipur', 'Bolpur', 'Bangaon', 'Cooch Behar', 'Tamluk', 'Raghunathganj', 'Murshidabad', 'Birbhum', 'Hooghly', 'Nadia', 'North 24 Parganas', 'South 24 Parganas', 'Paschim Bardhaman', 'Purba Bardhaman', 'Kalimpong', 'Jhargram', 'Paschim Medinipur', 'Purba Medinipur'],

        // Union Territories
        'Andaman and Nicobar Islands': ['Port Blair', 'Diglipur', 'Mayabunder', 'Rangat', 'Car Nicobar', 'Hut Bay', 'Nancowry', 'Campbell Bay'],
        'Chandigarh': ['Chandigarh'],
        'Dadra and Nagar Haveli and Daman and Diu': ['Daman', 'Diu', 'Silvassa', 'Nani Daman', 'Moti Daman', 'Amli', 'Khanvel'],
        'Delhi': ['Central Delhi', 'North Delhi', 'South Delhi', 'East Delhi', 'West Delhi', 'New Delhi', 'North East Delhi', 'North West Delhi', 'South East Delhi', 'South West Delhi', 'Shahdara'],
        'Jammu and Kashmir': ['Srinagar', 'Jammu', 'Anantnag', 'Baramulla', 'Kupwara', 'Pulwama', 'Rajouri', 'Kathua', 'Udhampur', 'Doda', 'Ganderbal', 'Bandipore', 'Reasi', 'Poonch', 'Ramban', 'Kishtwar', 'Samba', 'Shopian', 'Budgam', 'Kulgam'],
        'Ladakh': ['Leh', 'Kargil', 'Nubra', 'Zanskar', 'Drass', 'Nyoma'],
        'Lakshadweep': ['Kavaratti', 'Agatti', 'Amini', 'Andrott', 'Minicoy', 'Kalpeni', 'Kadmat', 'Kiltan', 'Chetlat', 'Bitra'],
        'Puducherry': ['Puducherry', 'Karaikal', 'Yanam', 'Mahe', 'Oulgaret', 'Villianur', 'Ozhukarai', 'Nettapakkam']
    };

    const [formData, setFormData] = useState({
        customerName: '',
        customerEmail: '',
        customerPhone: '',
        customerAddress: '',
        customerCity: '',
        customerState: '',
        customerDistrict: '',
        customerPincode: '',
        customerBirthday: '',
        orderAmount: '',
        paymentId: '',
        paymentMethod: 'UPI',
        notes: '',
        productIds: []
    });

    // Fetch products
    useEffect(() => {
        const productsRef = ref(db, 'HTAMS/company/products');
        const unsubscribe = onValue(productsRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const productsArray = Object.entries(data).map(([id, product]) => ({
                    id,
                    ...product,
                }));
                setProducts(productsArray);
            }
        });
        return () => unsubscribe();
    }, []);

    const showNotification = (message, type = 'info') => {
        setNotification({ show: true, message, type });
        setTimeout(() => {
            setNotification({ show: false, message: '', type: '' });
        }, 5000);
    };

    // Image compression function
    const compressImage = async (file) => {
        try {
            const options = {
                maxSizeMB: 0.05, // 50KB
                maxWidthOrHeight: 1024,
                useWebWorker: true,
                fileType: 'image/jpeg',
                initialQuality: 0.7
            };

            let compressedFile = await imageCompression(file, options);

            // If still larger than 50KB, try more aggressive compression
            let attempts = 0;
            while (compressedFile.size > 51200 && attempts < 5) {
                options.maxSizeMB = options.maxSizeMB * 0.8;
                options.initialQuality = options.initialQuality * 0.8;
                compressedFile = await imageCompression(file, options);
                attempts++;
            }

            console.log(`Original size: ${(file.size / 1024).toFixed(2)}KB`);
            console.log(`Compressed size: ${(compressedFile.size / 1024).toFixed(2)}KB`);

            return compressedFile;
        } catch (error) {
            console.error('Error compressing image:', error);
            throw error;
        }
    };

    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (!file.type.startsWith('image/')) {
            showNotification('Please upload an image file', 'error');
            return;
        }

        setLoading(true);
        try {
            // Compress the image
            const compressed = await compressImage(file);
            setCompressedImage(compressed);
            setImageSize({
                original: (file.size / 1024).toFixed(2),
                compressed: (compressed.size / 1024).toFixed(2)
            });

            // Create preview
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(compressed);

            showNotification(
                `Image compressed from ${(file.size / 1024).toFixed(2)}KB to ${(compressed.size / 1024).toFixed(2)}KB`,
                'success'
            );
        } catch (error) {
            showNotification('Failed to compress image', 'error');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const removeImage = () => {
        setImagePreview(null);
        setCompressedImage(null);
        setImageSize(null);
    };

    const handleQuantityChange = (productId, change) => {
        setProductQuantities(prev => {
            const currentQty = prev[productId] || 0;
            const newQty = Math.max(0, currentQty + change);

            if (newQty === 0) {
                const { [productId]: removed, ...rest } = prev;
                return rest;
            }

            return {
                ...prev,
                [productId]: newQty
            };
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // If state changes, update districts and reset district field
        if (name === 'customerState') {
            setDistricts(stateDistrictData[value] || []);
            setFormData(prev => ({
                ...prev,
                customerState: value,
                customerDistrict: '' // Reset district when state changes
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const validateForm = () => {
        if (!formData.customerName.trim()) {
            showNotification('Customer name is required', 'error');
            return false;
        }
        if (!formData.customerPhone.trim() || !/^[6-9]\d{9}$/.test(formData.customerPhone)) {
            showNotification('Valid 10-digit phone number is required', 'error');
            return false;
        }
        if (!formData.customerEmail.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.customerEmail)) {
            showNotification('Valid email is required', 'error');
            return false;
        }
        if (!formData.orderAmount || parseFloat(formData.orderAmount) <= 0) {
            showNotification('Valid order amount is required', 'error');
            return false;
        }
        if (!formData.paymentId.trim()) {
            showNotification('Payment ID/Transaction ID is required', 'error');
            return false;
        }
        if (!compressedImage) {
            showNotification('Payment screenshot is required', 'error');
            return false;
        }
        const selectedProductIds = Object.keys(productQuantities);
        if (selectedProductIds.length === 0 || Object.values(productQuantities).every(qty => qty === 0)) {
            showNotification('⚠️ Please select at least one product with quantity before submitting!', 'error');
            // Scroll to products section
            document.querySelector('.products-grid')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setLoading(true);
        try {
            // Upload image to Firebase Storage
            const timestamp = Date.now();
            const imageRef = storageRef(storage, `payment-proofs/${timestamp}_${compressedImage.name}`);
            await uploadBytes(imageRef, compressedImage);
            const imageUrl = await getDownloadURL(imageRef);

            // Prepare order data
            const orderData = {
                customerInfo: {
                    name: formData.customerName,
                    email: formData.customerEmail,
                    phone: formData.customerPhone,
                    address: formData.customerAddress,
                    city: formData.customerCity,
                    state: formData.customerState,
                    district: formData.customerDistrict,
                    pincode: formData.customerPincode,
                    birthday: formData.customerBirthday
                },
                orderDetails: {
                    amount: parseFloat(formData.orderAmount),
                    products: Object.entries(productQuantities).map(([id, quantity]) => {
                        const product = products.find(p => p.id === id);
                        return {
                            id,
                            name: product?.name || 'Unknown',
                            price: product?.price || 0,
                            quantity: quantity
                        };
                    })
                },
                paymentInfo: {
                    paymentId: formData.paymentId,
                    paymentMethod: formData.paymentMethod,
                    screenshotUrl: imageUrl,
                    screenshotSize: imageSize.compressed + 'KB'
                },
                notes: formData.notes,
                status: 'Pending Verification',
                submittedAt: new Date().toISOString(),
                timestamp: timestamp
            };

            // Save to Firebase
            const ordersRef = ref(db, 'HTAMS/orderNotPlaced');
            const newOrderRef = push(ordersRef);
            await set(newOrderRef, orderData);

            showNotification('Order submission successful! We will verify and process it soon.', 'success');

            // Reset form
            setFormData({
                customerName: '',
                customerEmail: '',
                customerPhone: '',
                customerAddress: '',
                customerCity: '',
                customerState: '',
                customerDistrict: '',
                customerPincode: '',
                customerBirthday: '',
                orderAmount: '',
                paymentId: '',
                paymentMethod: 'UPI',
                notes: '',
                productIds: []
            });
            setProductQuantities({});
            setDistricts([]);
            removeImage();

        } catch (error) {
            console.error('Error submitting order:', error);
            showNotification('Failed to submit order. Please try again.', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="order-not-placed-container">
            <style>{`
                .order-not-placed-container {
                    max-width: 100%;
                    margin: 0 auto;
                    padding: 20px;
                    background: #f9fafb;
                    min-height: 100vh;
                }

                .onp-header {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    color: white;
                    padding: 30px;
                    border-radius: 12px;
                    text-align: center;
                    margin-bottom: 30px;
                    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
                }

                .onp-header h1 {
                    margin: 0 0 10px 0;
                    font-size: 2rem;
                }

                .onp-header p {
                    margin: 0;
                    opacity: 0.95;
                    font-size: 1rem;
                }

                .onp-form {
                    background: white;
                    border-radius: 12px;
                    padding: 30px;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                }

                .form-section {
                    margin-bottom: 35px;
                    padding: 0px;
                }

                .section-title {
                    font-size: 1.3rem;
                    font-weight: 600;
                    color: #333;
                    margin-bottom: 20px;
                    padding-bottom: 10px;
                    border-bottom: 2px solid #667eea;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }

                .form-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
                    gap: 20px;
                }

                .form-group {
                    display: flex;
                    flex-direction: column;
                }

                .form-group label {
                    font-weight: 600;
                    color: #555;
                    margin-bottom: 8px;
                    font-size: 0.95rem;
                }

                .form-group input,
                .form-group select,
                .form-group textarea {
                    padding: 12px 15px;
                    border: 2px solid #e0e0e0;
                    border-radius: 8px;
                    font-size: 1rem;
                    transition: all 0.3s;
                    font-family: inherit;
                }

                .form-group input:focus,
                .form-group select:focus,
                .form-group textarea:focus {
                    outline: none;
                    border-color: #667eea;
                    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
                }

                .form-group textarea {
                    min-height: 100px;
                    resize: vertical;
                }

                .image-upload-section {
                    border: 2px dashed #667eea;
                    border-radius: 12px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 30px;
                    text-align: center;
                    background: #f8f9ff;
                    transition: all 0.3s;
                    cursor: pointer;
                }

                .image-upload-section:hover {
                    border-color: #764ba2;
                    background: #f0f2ff;
                }

                .image-upload-section input[type="file"] {
                    display: none;
                }

                .upload-prompt {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 15px;
                }

                .upload-icon {
                    font-size: 3rem;
                    color: #667eea;
                }

                .upload-text {
                    font-size: 1.1rem;
                    color: #555;
                    font-weight: 500;
                }

                .upload-subtext {
                    font-size: 0.9rem;
                    color: #888;
                }

                .image-preview-container {
                    position: relative;
                    margin-top: 20px;
                }

                .image-preview {
                    max-width: 100%;
                    max-height: 400px;
                    border-radius: 12px;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                }

                .remove-image-btn {
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    background: #f44336;
                    color: white;
                    border: none;
                    border-radius: 50%;
                    width: 40px;
                    height: 40px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.3);
                    transition: all 0.3s;
                }

                .remove-image-btn:hover {
                    background: #d32f2f;
                    transform: scale(1.1);
                }

                .image-size-info {
                    margin-top: 10px;
                    padding: 10px;
                    background: #e8f5e9;
                    border-radius: 8px;
                    color: #2e7d32;
                    font-size: 0.9rem;
                    display: flex;
                    justify-content: space-around;
                }

                .products-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
                    gap: 20px;
                }

                .product-card {
                    border: 1px solid #e0e0e0;
                    border-radius: 12px;
                    overflow: hidden;
                    cursor: default;
                    transition: all 0.3s;
                    background: white;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
                    display: flex;
                    flex-direction: column;
                }

                .product-card:hover {
                    box-shadow: 0 6px 20px rgba(0,0,0,0.15);
                    transform: translateY(-4px);
                }

                .product-card.selected {
                    border-color: #27ae60;
                    box-shadow: 0 6px 20px rgba(39, 174, 96, 0.3);
                }

                .product-image-container {
                    width: 100%;
                    height: 220px;
                    background: linear-gradient(135deg, #3d2817 0%, #5c4033 100%);
                    position: relative;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .product-image-container::before {
                    content: '';
                    position: absolute;
                    top: 10px;
                    left: 10px;
                    width: 40px;
                    height: 40px;
                    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2327ae60"><path d="M17 8C8 10 5.9 16.17 3.82 21.34l1.89.66.67-2.16c1.69.61 3.52.98 5.52.98 4.19 0 7.89-1.68 10.09-4.33-.03-.03-6.98-3.45-7.98-5.49zM3.5 9.65c-.96.18-1.66.5-2.5 1.35C2.3 13.05 4.8 14.65 8 15.5c.63.18 1.27.32 1.94.42C7.5 13.38 5.1 11.03 3.5 9.65z"/></svg>') no-repeat center;
                    background-size: contain;
                    opacity: 0.3;
                }

                .product-image-container::after {
                    content: '';
                    position: absolute;
                    bottom: 10px;
                    right: 10px;
                    width: 40px;
                    height: 40px;
                    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%2327ae60"><path d="M17 8C8 10 5.9 16.17 3.82 21.34l1.89.66.67-2.16c1.69.61 3.52.98 5.52.98 4.19 0 7.89-1.68 10.09-4.33-.03-.03-6.98-3.45-7.98-5.49zM3.5 9.65c-.96.18-1.66.5-2.5 1.35C2.3 13.05 4.8 14.65 8 15.5c.63.18 1.27.32 1.94.42C7.5 13.38 5.1 11.03 3.5 9.65z"/></svg>') no-repeat center;
                    background-size: contain;
                    opacity: 0.3;
                }

                .product-image {
                    width: 140px;
                    height: 180px;
                    object-fit: contain;
                    position: relative;
                    z-index: 1;
                    filter: drop-shadow(0 4px 8px rgba(0,0,0,0.3));
                }

                .product-info {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    padding: 20px;
                    flex: 1;
                }

                .product-name {
                    font-weight: 700;
                    color: #2c3e50;
                    font-size: 1.1rem;
                    line-height: 1.3;
                    min-height: 45px;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-transform: uppercase;
                    letter-spacing: 0.3px;
                }

                .product-category {
                    color: #7f8c8d;
                    font-size: 0.85rem;
                    text-transform: uppercase;
                    letter-spacing: 0.8px;
                }

                .product-price-stock {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin: 10px 0;
                }

                .product-price {
                    color: #e74c3c;
                    font-size: 1.4rem;
                    font-weight: 700;
                }

                .product-stock {
                    color: #7f8c8d;
                    font-size: 0.85rem;
                    font-weight: 600;
                }

                .product-stock.low-stock {
                    color: #e74c3c;
                }

                .product-stock.out-of-stock {
                    color: #c0392b;
                    font-weight: 700;
                }

                .add-to-cart-btn {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    color: white;
                    border: none;
                    padding: 14px 20px;
                    border-radius: 8px;
                    font-size: 1rem;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.3s;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
                }

                .add-to-cart-btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
                }

                .add-to-cart-btn:active {
                    transform: translateY(0);
                }

                .add-to-cart-btn.in-cart {
                    background: linear-gradient(135deg, #27ae60 0%, #229954 100%);
                    box-shadow: 0 4px 12px rgba(39, 174, 96, 0.3);
                    padding: 8px 12px;
                }

                .add-to-cart-btn.in-cart:hover {
                    box-shadow: 0 6px 16px rgba(39, 174, 96, 0.4);
                }

                .quantity-controls {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 12px;
                    width: 100%;
                }

                .qty-btn {
                    width: 32px;
                    height: 32px;
                    border: none;
                    background: white;
                    color: #27ae60;
                    font-size: 1.3rem;
                    font-weight: 700;
                    border-radius: 6px;
                    cursor: pointer;
                    transition: all 0.2s;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                }

                .qty-btn:hover:not(:disabled) {
                    background: #f8f9fa;
                    transform: scale(1.1);
                    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
                }

                .qty-btn:active:not(:disabled) {
                    transform: scale(0.95);
                }

                .qty-btn:disabled {
                    background: #e0e0e0;
                    color: #999;
                    cursor: not-allowed;
                    opacity: 0.6;
                }

                .qty-display {
                    font-size: 1.3rem;
                    font-weight: 700;
                    color: #2c3e50;
                    min-width: 45px;
                    text-align: center;
                    flex-shrink: 0;
                    background: white;
                    padding: 4px 8px;
                    border-radius: 6px;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                }

                .submit-btn {
                    background: linear-gradient(135deg, #4caf50 0%, #45a049 100%);
                    color: white;
                    border: none;
                    padding: 16px 40px;
                    border-radius: 8px;
                    font-size: 1.1rem;
                    font-weight: 600;
                    cursor: pointer;
                    width: 100%;
                    transition: all 0.3s;
                    box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
                }

                .submit-btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 16px rgba(76, 175, 80, 0.4);
                }

                .submit-btn:disabled {
                    background: #ccc;
                    cursor: not-allowed;
                    transform: none;
                    box-shadow: none;
                }

                .notification {
                    position: fixed;
                    top: 20px;
                    right: 20px;
                    padding: 16px 24px;
                    border-radius: 8px;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
                    z-index: 10000;
                    animation: slideIn 0.3s;
                    max-width: 400px;
                }

                .notification.success {
                    background: #4caf50;
                    color: white;
                }

                .notification.error {
                    background: #f44336;
                    color: white;
                }

                .notification.info {
                    background: #2196f3;
                    color: white;
                }

                @keyframes slideIn {
                    from {
                        transform: translateX(400px);
                        opacity: 0;
                    }
                    to {
                        transform: translateX(0);
                        opacity: 1;
                    }
                }

                .loading-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0,0,0,0.7);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 9999;
                }

                .loading-spinner {
                    width: 60px;
                    height: 60px;
                    border: 5px solid #fff;
                    border-top-color: #667eea;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                }

                @keyframes spin {
                    to { transform: rotate(360deg); }
                }

                @media (max-width: 768px) {
                    .order-not-placed-container {
                        padding: 10px;
                    }

                    .onp-header {
                        padding: 20px 15px;
                    }

                    .onp-header h1 {
                        font-size: 1.3rem;
                    }

                    .onp-header p {
                        font-size: 0.85rem;
                    }

                    .onp-form {
                        padding: 15px;
                    }

                    .section-title {
                        font-size: 1rem;
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 8px;
                    }

                    .section-title span {
                        margin-left: 0 !important;
                        font-size: 0.75rem !important;
                        padding: 3px 10px !important;
                    }

                    .form-grid {
                        grid-template-columns: 1fr;
                    }

                    .products-grid {
                        grid-template-columns: 1fr;
                        gap: 15px;
                    }

                    .product-card {
                        max-width: 100%;
                    }

                    .product-image-container {
                        height: 200px;
                    }

                    .product-image {
                        width: 120px;
                        height: 160px;
                    }

                    .product-info {
                        padding: 15px;
                    }

                    .product-name {
                        font-size: 1rem;
                        min-height: 42px;
                    }

                    .product-category {
                        font-size: 0.8rem;
                    }

                    .product-price {
                        font-size: 1.3rem;
                    }

                    .product-stock {
                        font-size: 0.8rem;
                    }

                    .add-to-cart-btn {
                        padding: 12px 16px;
                        font-size: 0.95rem;
                    }

                    .add-to-cart-btn.in-cart {
                        padding: 6px 10px;
                    }

                    .qty-btn {
                        width: 30px;
                        height: 30px;
                        font-size: 1.2rem;
                    }

                    .qty-display {
                        font-size: 1.2rem;
                        min-width: 35px;
                    }

                    .quantity-controls {
                        gap: 10px;
                    }

                    .notification {
                        top: 10px;
                        right: 10px;
                        left: 10px;
                        max-width: none;
                        font-size: 0.9rem;
                    }
                }
            `}</style>

            {/* Notification */}
            {notification.show && (
                <div className={`notification ${notification.type}`}>
                    {notification.message}
                </div>
            )}

            {/* Loading Overlay */}
            {loading && (
                <div className="loading-overlay">
                    <div className="loading-spinner"></div>
                </div>
            )}

            {/* Header */}
            <div className="onp-header">
                <h1>📋 Order Not Placed - Submit Proof</h1>
                <p>If your order wasn't placed successfully, submit your payment proof here for manual verification</p>
            </div>

            {/* Form */}
            <form className="onp-form" onSubmit={handleSubmit}>
                {/* Customer Information */}
                <div className="form-section">
                    <h2 className="section-title">
                        👤 Customer Information
                    </h2>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Full Name *</label>
                            <input
                                type="text"
                                name="customerName"
                                value={formData.customerName}
                                onChange={handleInputChange}
                                placeholder="Enter full name"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>Email Address *</label>
                            <input
                                type="email"
                                name="customerEmail"
                                value={formData.customerEmail}
                                onChange={handleInputChange}
                                placeholder="email@example.com"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>Phone Number *</label>
                            <input
                                type="tel"
                                name="customerPhone"
                                value={formData.customerPhone}
                                onChange={handleInputChange}
                                placeholder="10-digit mobile number"
                                maxLength="10"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>Birthday</label>
                            <input
                                type="date"
                                name="customerBirthday"
                                value={formData.customerBirthday}
                                onChange={handleInputChange}
                                max={new Date().toISOString().split('T')[0]}
                            />
                        </div>
                        <div className="form-group">
                            <label>State *</label>
                            <select
                                name="customerState"
                                value={formData.customerState}
                                onChange={handleInputChange}
                                required
                            >
                                <option value="">Select State</option>
                                {Object.keys(stateDistrictData).map(state => (
                                    <option key={state} value={state}>{state}</option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label>District *</label>
                            <select
                                name="customerDistrict"
                                value={formData.customerDistrict}
                                onChange={handleInputChange}
                                disabled={!formData.customerState}
                                required
                            >
                                <option value="">Select District</option>
                                {districts.map(district => (
                                    <option key={district} value={district}>{district}</option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Pincode</label>
                            <input
                                type="text"
                                name="customerPincode"
                                value={formData.customerPincode}
                                onChange={handleInputChange}
                                placeholder="6-digit pincode"
                                maxLength="6"
                            />
                        </div>
                    </div>
                    <div className="form-group" style={{ marginTop: '20px' }}>
                        <label>Address</label>
                        <textarea
                            name="customerAddress"
                            value={formData.customerAddress}
                            onChange={handleInputChange}
                            placeholder="Enter complete address"
                        />
                    </div>
                </div>

                {/* Product Selection */}
                <div className="form-section">
                    <h2 className="section-title">
                        🛍️ Select Products
                        <span style={{
                            marginLeft: '15px',
                            fontSize: '0.9rem',
                            fontWeight: '500',
                            padding: '4px 12px',
                            borderRadius: '20px',
                            background: Object.keys(productQuantities).length > 0 ? '#4caf50' : '#ff9800',
                            color: 'white'
                        }}>
                            {Object.keys(productQuantities).length} Products ({Object.values(productQuantities).reduce((sum, qty) => sum + qty, 0)} Items)
                        </span>
                    </h2>
                    <div className="products-grid">
                        {products
                            .filter(product =>
                                product.status === 'active' &&
                                product.stock > 0
                            )
                            .map(product => {
                                const quantity = productQuantities[product.id] || 0;
                                return (
                                    <div
                                        key={product.id}
                                        className={`product-card ${quantity > 0 ? 'selected' : ''}`}
                                    >
                                        {/* Product Image */}
                                        <div className="product-image-container">
                                            {product.imageUrls && product.imageUrls[0] ? (
                                                <img
                                                    src={product.imageUrls[0]}
                                                    alt={product.name}
                                                    className="product-image"
                                                />
                                            ) : (
                                                <div className="product-image" style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    color: 'white',
                                                    fontSize: '0.9rem',
                                                    textAlign: 'center',
                                                    padding: '20px'
                                                }}>
                                                    📦<br />No Image
                                                </div>
                                            )}
                                        </div>

                                        {/* Product Info */}
                                        <div className="product-info">
                                            <div className="product-name">{product.name}</div>
                                            <div className="product-category">{product.category || 'AYURVEDIC PRODUCT'}</div>

                                            <div className="product-price-stock">
                                                <div className="product-price">₹{product.price || product.mrp}</div>
                                                <div className={`product-stock ${product.stock === 0 ? 'out-of-stock' :
                                                    product.stock < 50 ? 'low-stock' : ''
                                                    }`}>
                                                    Stock: {product.stock || 0}
                                                </div>
                                            </div>

                                            {/* Add to Cart Button */}
                                            <button
                                                type="button"
                                                className={`add-to-cart-btn ${quantity > 0 ? 'in-cart' : ''}`}
                                            >
                                                {quantity > 0 ? (
                                                    <div className="quantity-controls">
                                                        <button
                                                            type="button"
                                                            className="qty-btn"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleQuantityChange(product.id, -1);
                                                            }}
                                                            disabled={quantity === 0}
                                                        >
                                                            −
                                                        </button>
                                                        <span className="qty-display">{quantity}</span>
                                                        <button
                                                            type="button"
                                                            className="qty-btn"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleQuantityChange(product.id, 1);
                                                            }}
                                                            disabled={quantity >= product.stock}
                                                        >
                                                            +
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <div onClick={() => handleQuantityChange(product.id, 1)} style={{ cursor: 'pointer', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                                        🛒 Add to Cart
                                                    </div>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        {
                            products.filter(p => p.status === 'active' && p.stock > 0).length === 0 && (
                                <div style={{
                                    gridColumn: '1 / -1',
                                    textAlign: 'center',
                                    padding: '40px 20px',
                                    color: '#999',
                                    fontSize: '1.1rem'
                                }}>
                                    📭 No products available at the moment
                                </div>
                            )
                        }
                    </div >
                    {
                        Object.keys(productQuantities).length === 0 && products.filter(p => p.status === 'active' && p.stock > 0).length > 0 && (
                            <div style={{
                                marginTop: '15px',
                                padding: '12px 20px',
                                background: '#fff3cd',
                                border: '1px solid #ffc107',
                                borderRadius: '8px',
                                color: '#856404',
                                fontSize: '0.95rem',
                                textAlign: 'center'
                            }}>
                                ⚠️ Please select product quantities using +/- buttons to continue
                            </div>
                        )
                    }
                </div >

                {/* Payment Information */}
                < div className="form-section" >
                    <h2 className="section-title">
                        💳 Payment Information
                    </h2>
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Order Amount (₹) *</label>
                            <input
                                type="number"
                                name="orderAmount"
                                value={formData.orderAmount}
                                onChange={handleInputChange}
                                placeholder="Enter total amount paid"
                                step="0.01"
                                min="0"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label>Payment Method *</label>
                            <select
                                name="paymentMethod"
                                value={formData.paymentMethod}
                                onChange={handleInputChange}
                                required
                            >
                                <option value="UPI">UPI</option>
                                <option value="Net Banking">Net Banking</option>
                                <option value="Credit Card">Credit Card</option>
                                <option value="Debit Card">Debit Card</option>
                                <option value="Cash">Cash</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>Payment ID / Transaction ID *</label>
                            <input
                                type="text"
                                name="paymentId"
                                value={formData.paymentId}
                                onChange={handleInputChange}
                                placeholder="Enter payment/transaction ID"
                                required
                            />
                        </div>
                    </div>
                </div >

                {/* Payment Screenshot */}
                < div className="form-section" >
                    <h2 className="section-title">
                        📸 Payment Screenshot *
                    </h2>

                    {
                        !imagePreview ? (
                            <label className="image-upload-section">
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageUpload}
                                />
                                <div className="upload-prompt">
                                    <FaCloudUploadAlt className="upload-icon" />
                                    <div className="upload-text">Click to upload payment screenshot</div>
                                    <div className="upload-subtext">Image will be automatically compressed to under 50KB</div>
                                </div>
                            </label>
                        ) : (
                            <div className="image-preview-container">
                                <img src={imagePreview} alt="Payment proof" className="image-preview" />
                                <button
                                    type="button"
                                    className="remove-image-btn"
                                    onClick={removeImage}
                                >
                                    <FaTrash />
                                </button>
                                {imageSize && (
                                    <div className="image-size-info">
                                        <div>Original: {imageSize.original}KB</div>
                                        <div>Compressed: {imageSize.compressed}KB</div>
                                        <div>
                                            {parseFloat(imageSize.compressed) <= 50 ? (
                                                <span style={{ color: '#4caf50' }}>
                                                    <FaCheckCircle /> Perfect!
                                                </span>
                                            ) : (
                                                <span style={{ color: '#f44336' }}>
                                                    <FaTimesCircle /> Still large
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )
                    }
                </div >

                {/* Additional Notes */}
                < div className="form-section" >
                    <h2 className="section-title">
                        📝 Additional Notes
                    </h2>
                    <div className="form-group">
                        <label>Notes (Optional)</label>
                        <textarea
                            name="notes"
                            value={formData.notes}
                            onChange={handleInputChange}
                            placeholder="Any additional information or issues you faced..."
                        />
                    </div>
                </div >

                {/* Submit Button */}
                < button
                    type="submit"
                    className="submit-btn"
                    disabled={loading}
                >
                    {loading ? 'Submitting...' : 'Submit Order Proof'}
                </button >
            </form >
        </div >
    );
};

export default OrderNotPlaced;
